type EventCallback<T = unknown> = (data: T) => void

const listeners = new Map<string, Set<EventCallback>>()

export function emit<T>(event: string, data: T): void {
  const callbacks = listeners.get(event)
  if (!callbacks) return
  for (const callback of callbacks) {
    callback(data)
  }
}

export function on<T>(event: string, callback: EventCallback<T>): () => void {
  const existing = listeners.get(event) ?? new Set<EventCallback>()
  existing.add(callback as EventCallback)
  listeners.set(event, existing)

  return () => {
    off(event, callback)
  }
}

export function off<T>(event: string, callback: EventCallback<T>): void {
  const existing = listeners.get(event)
  if (!existing) return
  existing.delete(callback as EventCallback)
  if (existing.size === 0) {
    listeners.delete(event)
  }
}

export function clearAllListeners(): void {
  listeners.clear()
}
